import { IconNotificationBellOn } from '@adtech/ui';
import IconUser from '@images/svg/icons/icon-user.svg';
import IconUsersList from '@images/svg/icons/icon-users-list.svg';
import { IUsersValue } from '@typings/counter';
import { IAccessRequestByProject } from '@typings/projects';
import React from 'react';

import AccessRequestsTable from './AccessRequestsTable';
import s from './AccessUsers.pcss';
import AddUserForm from './AddUserForm';
import UsersTable from './UsersTable';

interface IProps {
    usersList: IUsersValue[];
    accessRequestsListByProject: IAccessRequestByProject[];
}

const AccessUsers: React.FC<IProps> = ({ usersList, accessRequestsListByProject }) => (
    <>
        <section className={s.section}>
            <div className={s.sectionTitle}>
                <IconUser className={s.sectionIcon} />
                Добавление пользователя
            </div>
            <AddUserForm usersList={usersList} />
        </section>
        {accessRequestsListByProject?.length > 0 && (
            <section className={s.section}>
                <div className={s.sectionTitle}>
                    <IconNotificationBellOn className={s.sectionIcon} />
                    Запросы доступов
                </div>
                <AccessRequestsTable accessRequestsListByProject={accessRequestsListByProject} />
            </section>
        )}
        <section className={s.section}>
            <div className={s.sectionTitle}>
                <IconUsersList className={s.sectionIcon} />
                Список пользователей
            </div>
            <UsersTable usersListProp={usersList} />
        </section>
    </>
);

export default AccessUsers;
